<template>
  <div class="warp">
    <!-- 头部工具栏 -->
    <div class="company_heard_tool">
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog('添加职位')">添加</el-button>
      <el-button type="warning" size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
      <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteGroup">批量删除</el-button>
      <el-button type="success" size="mini" icon="el-icon-info" @click="getPendingList">
        <span>审核( {{ statusCount.count || 0 }} )</span>
        <i v-show="statusCount.loading" class="el-icon-loading" />
      </el-button>
    </div>
    <!-- 筛选 -->
    <el-form ref="screenForm" :inline="true" :model="screenForm" class="demo-form-inline">
      <el-form-item label="发布企业账号：" prop="username">
        <el-input v-model="screenForm.username" />
      </el-form-item>
      <el-form-item label="所属企业：" prop="companyName">
        <el-input v-model="screenForm.companyName" />
      </el-form-item>
      <el-form-item label="认证状态：" prop="auth">
        <el-select v-model="screenForm.status" placeholder="不限" clearable>
          <el-option label="审核中" :value="0" />
          <el-option label="认证通过" :value="1" />
          <el-option label="认证失败" :value="2" />
        </el-select>
      </el-form-item>
      <el-button type="primary" size="mini" icon="el-icon-search" style="margin-right: 10px" @click="screenData">筛选</el-button>
    </el-form>
    <div ref="tableWrap" style="flex: 1">
      <el-table
        v-if="tableH"
        v-loading="loading"
        :max-height="tableH - 47"
        :data="tableData"
        tooltip-effect="dark"
        :border="true"
        size="mini"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" />
        <el-table-column label="编号">
          <template slot-scope="scope">
            <span v-if="categoryOpt.length">{{ scope.row.sn || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发布账号">
          <template slot-scope="scope">
            <span v-if="categoryOpt.length">{{ scope.row.companyAccount || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属企业">
          <template slot-scope="scope">
            <span v-if="categoryOpt.length">{{ scope.row.company ? scope.row.company.companyName : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="jobType" label="招聘类型" width="100" />
        <el-table-column label="工作分类">
          <template slot-scope="scope">
            <span v-if="categoryOpt.length">{{
              categoryOpt.find((item) => item.value == scope.row.jobCategoryId) ? categoryOpt.find((item) => item.value == scope.row.jobCategoryId).label : '-'
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="招聘职位" width="120">
          <template slot-scope="scope">
            <span v-if="categoryOpt.length">{{ scope.row.jobTitle || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="jobName" label="职位名称" width="120" />
        <el-table-column prop="salaryRange" label="薪资范围" width="120" />
        <el-table-column prop="jobLabels" label="职位标签" width="120" />
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.isPublished" style="color: #67c23a">发布中</span>
            <span v-else style="color: #909399">已下架</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="后台审核状态" width="120">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.status" class="column_radio" @change="verifyJob($event, scope.row.id)">
              <el-radio :label="0" style="color: #f7d022">审核中</el-radio>
              <el-radio :label="1" style="color: #1fe65b">认证通过</el-radio>
              <el-radio :label="2" style="color: #ee4b4b">认证拒绝</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column label="热门设置" width="220">
          <template slot-scope="scope">
            <div class="flex-center" style="width: 100%; color: #666" @click="toggleHotJob({ jobId: scope.row.id })">
              <div
                class="flex-center"
                style="border-radius: 50%; width: 20px; height: 20px; border: 1px solid #ccc; margin-top: -2px"
                :class="scope.row.isMemberIndexHot ? 'isHot' : 'notHot'"
              >
                <i class="el-icon-check" style="font-weight: blod; color: #fff" />
              </div>
              <span class="flex-center" style="margin-left: 8px" :style="{ color: scope.row.isMemberIndexHot ? '#f19641' : '#666' }">用户端首页热门推荐</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="orders" label="已接收简历" width="120">
          <template slot-scope="scope"> {{ scope.row.numbers || 0 }}</template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="100" />
        <el-table-column prop="address" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="openDialog('编辑职位', scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" style="margin: 6px 0 0" @click="handleDeleteCompany(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 15px 0 0">
        <el-pagination
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <!-- 添加 编辑对话框 -->
    <el-dialog :close-on-click-modal="false" width="800px" :title="dialogTitle" :visible.sync="showDialog" append-to-body @close="resetForm">
      <el-form ref="form" label-position="left" :rules="rules" :model="form" label-width="80px">
        <el-form-item label-width="100px" prop="companyId" label="发布企业账号：">
          <el-select
            v-model="form.companyId"
            filterable
            remote
            clearable
            placeholder="请输入企业账号进行搜索"
            :remote-method="getCompanyByAccount"
            :loading="loading"
          >
            <el-option v-for="item in companyOpt" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <i v-show="searching" class="el-icon-loading" style="margin-left: 10px" />
        </el-form-item>
        <el-form-item prop="jobType" label-width="100px" label="招聘类型：">
          <div class="flex-center" style="width: 100%; min-height: 28px; justify-content: flex-start">
            <el-radio-group v-model="form.jobType">
              <el-radio label="FULL">全职</el-radio>
              <el-radio label="PART">兼职</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item prop="jobCategoryId" label-width="100px" label="工作分类：">
          <div class="flex-center" style="width: 100%; min-height: 28px; justify-content: flex-start">
            <el-radio-group v-model="form.jobCategoryId">
              <el-radio v-for="item in categoryOpt" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item prop="jobTitleId" label-width="100px" label="招聘职位：">
          <div v-show="!jobTitleOpt.length" class="flex-center" style="width: 100%; min-height: 28px; justify-content: flex-start">
            <div class="flex-center"><span v-show="!jobTitleLoading">-</span> <i v-show="jobTitleLoading" class="el-icon-loading" /></div>
          </div>
          <div v-show="jobTitleOpt.length" class="flex-center" style="width: 100%; min-height: 28px; justify-content: flex-start">
            <el-radio-group v-model="form.jobTitleId">
              <el-radio v-for="item in jobTitleOpt" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item prop="salaryRange" label-width="100px" label="薪资范围：">
          <div class="flex-center" style="width: 100%; min-height: 28px; justify-content: flex-start">
            <el-radio-group v-model="form.salaryRange">
              <el-radio v-for="item in salaryOpt" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item prop="jobLabels" label-width="100px" label="职位标签：">
          <div class="flex-center" style="width: 100%; min-height: 28px; justify-content: flex-start">
            <el-radio-group v-model="form.jobLabels">
              <el-checkbox-group v-model="checkedCities" :min="0" :max="5">
                <el-checkbox v-for="item in jobLabelsOpt" :key="item.value" :label="item.value"></el-checkbox>
              </el-checkbox-group>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item prop="jobName" label-width="100px" label="职位名称：">
          <el-input v-model="form.jobName" style="max-width: 300px" />
        </el-form-item>
        <el-form-item prop="description" label-width="100px" label="职位描述：">
          <el-input v-model="form.description" type="textarea" resize="none" :rows="4" autocomplete="off" />
        </el-form-item>
        <!-- 上传图片 -->
        <el-form-item prop="jobImages" label-width="100px" label="职位图片视频：">
          <el-upload
            :on-success="handleFuliSuccess"
            :before-upload="beforeImagesUpload"
            :with-credentials="true"
            action="/api/admin/file/upload"
            list-type="picture-card"
            :file-list="form.jobImages"
            :on-remove="handleFuliRemove"
          >
            <i class="el-icon-plus" />
            <div slot="file" slot-scope="{ file }">
              <img v-if="isImage(file.url)" :src="file.url" style="width: 76px; height: 76px; display: block" />
              <video v-else :src="file.url" style="width: 76px; height: 76px; display: block" />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="isImage(file.url) ? previewImage(file.url) : previewVideo(file.url)">
                  <i class="el-icon-zoom-in" />
                </span>
                <span class="el-upload-list__item-delete" @click="handleFuliRemove(file)">
                  <i class="el-icon-delete" />
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item prop="isPublished" label-width="100px" label="状态：">
          <el-radio-group v-model="form.isPublished">
            <el-radio :label="1">发布中</el-radio>
            <el-radio :label="0">已下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label-width="100px" prop="status" label="后台审核状态：">
          <div style="line-height: 28px">
            <el-radio-group v-model="form.status">
              <el-radio :label="0">审核中</el-radio>
              <el-radio :label="1">认证通过</el-radio>
              <el-radio :label="2">认证拒绝</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item v-if="form.status == 2" label-width="100px" prop="rejectReason" label="拒绝原因：">
          <el-input v-model="form.rejectReason" autocomplete="off" clearable resize="none" type="textarea" />
        </el-form-item>
        <el-form-item prop="isMemberIndexHot" label-width="100px" label="热门设置">
          <div
            :style="{ color: form.isMemberIndexHot ? '#f19641' : '#666' }"
            style="display: flex; justify-content: center; align-items: center; width: max-content; height: 28px"
            @click="form.isMemberIndexHot = !form.isMemberIndexHot"
          >
            <div
              style="border-radius: 50%; width: 20px; height: 20px; line-height: 20px; text-align: center; display: inline-block"
              :style="{ background: form.isMemberIndexHot ? '#f19641' : 'none', border: form.isMemberIndexHot ? 'none' : '1px solid #ccc' }"
            >
              <i v-show="form.isMemberIndexHot" class="el-icon-check" style="font-weight: blod; color: #fff" />
            </div>
            <div style="padding: 2px 0 0 8px; display: inline; line-height: 20px">用户端首页热门推荐</div>
          </div>
        </el-form-item>
        <el-form-item prop="poiAddress" label-width="100px" label="公司地址：">
          <div style="width: 100%; height: 100%">
            <div id="map" class="map-container" style="width: 100%; height: 300px">
              <el-amap class="amap-box" vid="map'amap-vue'" :zoom="8" :center="mapCenter" :events="events">
                <!-- 标记 -->
                <el-amap-marker v-if="mapCenter" :position="mapCenter" />
              </el-amap>
            </div>
            <div style="width: 100%; display: flex; line-height: 30px; margin-top: 15px; justify-content: space-between">
              <div class="flex-center" style="align-self: flex-start">
                <span class="area"> <i v-show="gettingAddress" style="padding: 0 10px" class="el-icon-loading" />已选地址：</span>
              </div>
              <div style="flex: 1; display: flex; flex-wrap: wrap">
                <span v-if="form.poiProvince" class="area">{{ form.poiProvince.length && form.poiProvince !== '[]' ? form.poiProvince : '-' }}</span>
                <span v-if="form.poiCity" class="area">{{ form.poiCity.length && form.poiCity !== '[]' ? form.poiCity : '-' }}</span>
                <span v-if="form.poiDistrict" class="area">{{ form.poiDistrict.length && form.poiDistrict !== '[]' ? form.poiDistrict : '-' }}</span>
                <div v-if="form.poiAddress" style="box-sizing: border-box; padding: 0 5px; width: 100%">
                  <el-input v-model="form.poiAddress" type="textarea" resize="none" />
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit(dialogTitle === '添加职位')">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="previewImageDialog">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <el-dialog :visible.sync="previewVideoDialog">
      <video v-if="previewVideoDialog" width="100%" :src="videoUrl" controls autoplay />
    </el-dialog>
  </div>
</template>
<script>
// import { deepClone } from '@/utils'
import pagination from '@/mixins/pagination'
export default {
  mixins: [pagination],
  data() {
    const self = this
    const addressValidator = (rule, value, cb) => {
      const { poiAddress, poiCity, poiDistrict, poiProvince } = self.form

      if (poiAddress && poiAddress !== '[]' && poiCity && poiCity !== '[]' && poiDistrict && poiDistrict !== '[]' && poiProvince && poiProvince !== '[]') {
        cb()
      } else {
        cb(new Error('当前地址不准确，请选择一个准确的地址'))
      }
    }
    const imagesValidator = (rule, value, callback) => {
      if (value.length) {
        return callback()
      } else {
        callback(new Error('请至少上传一张照片或一段视频'))
      }
    }
    return {
      tableH: 0,
      videoUrl: '',
      previewVideoDialog: false,
      statusCount: {
        count: 0,
        loading: true
      },
      options: [
        {
          value: '选项1',
          label: '不限'
        },
        {
          value: '选项2',
          label: '审核中'
        },
        {
          value: '选项3',
          label: '审核通过'
        },
        {
          value: '选项4',
          label: '审核拒绝'
        }
      ],
      value: '',
      companyOpt: [],
      jobTitleOpt: [],
      categoryOpt: [],
      salaryOpt: [],
      jobLabelsOpt: [],
      checkedCities: [],
      ids: [],
      jobTitleLoading: false,
      tableData: [],
      loading: true,
      searching: false,
      showDialog: false,
      dialogTitle: '',
      screenForm: {
        username: '',
        companyName: '',
        status: null
      },
      form: {
        status: null,
        companyAccountId: null,
        companyId: null,
        jobType: null,
        jobCategoryId: null,
        salaryRange: '',
        jobTitleId: null,
        isPublished: null,
        jobName: '',
        description: '',
        jobImages: [],
        isMemberIndexHot: false,
        poiLon: 0,
        poiLat: 0,
        poiProvince: '',
        poiCityL: '',
        poiCounty: '',
        poiAddress: '',
        rejectReason: ''
      },
      rules: {
        status: [{ required: true, message: '请选择认证状态', trigger: 'change' }],
        companyId: [{ required: true, message: '请选择搜索并选择企业', trigger: 'change' }],
        jobType: [{ required: true, message: '请选择工作类型', trigger: 'change' }],
        jobCategoryId: [{ required: true, message: '请选择工作分类', trigger: 'change' }],
        salaryRange: [{ required: true, message: '请选择薪资范围', trigger: 'change' }],
        jobTitleId: [{ required: true, message: '请选择招聘职位', trigger: 'change' }],
        isPublished: [{ required: true, message: '请选择工作状态', trigger: 'change' }],
        jobName: [{ required: true, message: '请输入工作名称', trigger: 'blur' }],
        description: [{ required: true, message: '请填写工作描述', trigger: 'blur' }],
        poiAddress: [{ required: true, validator: addressValidator, trigger: 'change' }]
      },
      mapCenter: [113, 23],
      marker: [113, 23],
      gettingAddress: false,
      events: {
        // 点击获取地址的数据
        click(e) {
          const { lng, lat } = e.lnglat
          self.getAddress(lng, lat)
          self.form.poiLon = lng
          self.form.poiLat = lat
          self.mapCenter = null
          self.mapCenter = [lng, lat]
          const geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: 'all'
          })
        }
      }
    }
  },

  computed: {
    jobImages() {
      return (this.form.jobImages || []).map((item) => {
        return {
          url: item
        }
      })
    }
  },
  watch: {
    'form.jobCategoryId': {
      handler(id) {
        this.getJobTitleOpt(id)
      }
    },
    'form.poiAddress': {
      handler(v) {
        this.form.poiAddress = v === '[]' ? '' : v
      }
    }
  },
  created() {
    this.getTableList()
    this.getJobTitleCategory(), this.getSalaryRange(), this.getJobLabels()
  },
  mounted() {
    this.getVerifyCount()
    this.getTableList()
    this.tableH = this.$refs.tableWrap.clientHeight
  },
  methods: {
    verifyJob(status, id) {
      console.log(status, 256454)
      if (status === 2) {
        this.$prompt('请输入拒绝原因，拒绝原因不能为空', '拒绝原因', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: '',
          inputValidator(value) {
            if (value == undefined) {
              return '拒绝原因不能为空'
            }
          },
          inputErrorMessage: '请输入拒绝原因'
        })
          .then((items) => {
            this.getJobStatus(status, id, items.value)
            this.$message({
              type: 'success',
              message: '成功'
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            })
          })
      } else {
        this.getJobStatus(status, id)
      }
    },
    getJobStatus(status, id, rejectReason) {
      this.loading = true
      this.$api.company
        .reqUpdateJobStatus({ status, id, rejectReason })
        .then((res) => {
          this.loading = false
          this.getVerifyCount()
          this.$message.success('操作成功')
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e)
        })
    },
    getCompanyByAccount(username) {
      this.searching = true
      this.companyOpt = []
      this.$api.company
        .reqCompanyByAccount({ username })
        .then((res) => {
          this.form.companyAccountId = res.companyAccountId
          this.companyOpt = [
            {
              value: res.companyId,
              label: res.companyName
            }
          ]
          this.searching = false
        })
        .catch(() => {
          this.companyOpt = []
          this.searching = false
        })
    },
    getPendingList() {
      this.$refs.screenForm.resetFields()
      this.checkedCities = []
      this.screenForm.status = 0
      this.screenData()
    },
    beforeImagesUpload(file) {
      const isImg = /image/.test(file.type)
      const isVideo = /video/.test(file.type)
      if (!isImg && !isVideo) {
        this.$message.error('只能上传图片或者视频')
      }
      return isImg || isVideo
    },
    getTableList() {
      this.loading = true
      return this.$api.company
        .reqJobList(this.page)
        .then((res) => {
          // console.log(res)
          this.tableData = res.records
          this.total = res.total
          const ids = this.tableData
            .filter((item) => item.companyId)
            .map((item) => item.companyId)
            .join(',')
          const jobTitleId = this.tableData
            .filter((item) => item.jobTitleId)
            .map((item) => item.jobTitleId)
            .join(',')
          const companyAccountId = this.tableData
            .filter((item) => item.companyAccountId)
            .map((item) => item.companyAccountId)
            .join(',')
          Promise.all([this.getCompanyList({ ids }), this.getJobTitle({ jobTitleId }), this.getCompanyAccount({ companyAccountId })]).then(() => {
            this.loading = false
          })
        })
        .catch(() => {})
    },
    getCompanyList(data) {
      if (!data.ids) return Promise.resolve('1')
      return this.$api.company
        .reqCompanyList(data)
        .then((res) => {
          const companyList = res
          const map = new Map()
          companyList.forEach((item) => {
            map[item.id] = item
          })
          this.tableData.forEach((item) => {
            item.company = map[item.companyId]
          })
          this.tableData = JSON.parse(JSON.stringify(this.tableData))
        })
        .catch((e) => {
          console.error(e)
          this.loading = false
        })
    },
    getJobTitle(data) {
      return this.$api.company
        .reqJobTitle(data)
        .then((res) => {
          this.tableData.forEach((item) => {
            res.forEach((i) => {
              if (i.id === item.jobTitleId) {
                this.$set(item, 'jobTitle', i.name)
              }
            })
          })
        })
        .catch((e) => {})
    },
    isImage(url) {
      const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
      let format = url.split('.')
      console.log('zhixing')
      console.log(format)
      format = format[format.length - 1]
      if (imglist.some((item) => item === format)) {
        return true
      } else {
        return false
      }
    },
    previewVideo(url) {
      this.videoUrl = url
      this.previewVideoDialog = true
    },
    screenData() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      Object.assign(this.page, this.screenForm)
      Promise.all([this.getVerifyCount(), this.getTableList()])
        .then(() => {
          this.loading = false
          this.statusCount.loading = false
        })
        .catch(() => {})
    },
    getAddress(lon, lat) {
      if (this.gettingAddress) return
      this.gettingAddress = true
      this.$api.common
        .reqGeocoder({ lat, lon })
        .then((res) => {
          this.form.poiAddress = res.address
          this.form.poiCity = res.city
          this.form.poiDistrict = res.district
          this.form.poiProvince = res.province
          this.gettingAddress = false
        })
        .catch(() => (this.gettingAddress = false))
        .finally(() => {
          if (
            this.form.poiAddress &&
            this.form.poiAddress !== '[]' &&
            this.form.poiCity &&
            this.form.poiCity !== '[]' &&
            this.form.poiDistrict &&
            this.form.poiDistrict !== '[]' &&
            this.form.poiProvince &&
            this.form.poiProvince !== '[]'
          ) {
            this.$refs.form.clearValidate('poiAddress')
          } else {
            this.$refs.form.validateField('poiAddress')
          }
        })
    },
    toggleHotJob(data) {
      this.loading = true
      this.$api.company
        .reqToggleJobHot(data)
        .then((res) => {
          this.$message.success(res)
          this.getTableList()
        })
        .catch((e) => {
          this.$message.error(e)
        })
    },
    getCompanyAccount(data) {
      return this.$api.company
        .reqCompanyAccount(data)
        .then((res) => {
          this.tableData.forEach((item) => {
            res.forEach((i) => {
              if (i.id == item.companyAccountId) {
                this.$set(item, 'companyAccount', i.username)
              }
            })
          })
        })
        .catch((e) => {})
    },
    getJobTitleCategory() {
      this.$api.company
        .reqJobTitleCategory()
        .then((res) => {
          this.categoryOpt = res.map((item) => {
            return {
              value: item.id,
              label: item.name
            }
          })
        })
        .catch((e) => {})
    },
    getJobTitleOpt(jobCategoryId) {
      this.jobTitleLoading = true
      this.jobTitleOpt = []
      return this.$api.company
        .reqJobTitleOpt({ jobCategoryId })
        .then((res) => {
          this.jobTitleOpt = res.map((item) => {
            return {
              value: item.id,
              label: item.name
            }
          })
          this.jobTitleLoading = false
          return res
        })
        .catch(() => (this.jobTitleLoading = false))
    },
    getSalaryRange() {
      this.$api.company
        .reqSalaryRange()
        .then((res) => {
          this.salaryOpt = res.map((item) => {
            return {
              value: item,
              label: item
            }
          })
        })
        .catch((e) => {})
    },
    // 获取职位标签列表
    getJobLabels() {
      this.$api.company
        .reqJobLabels()
        .then((res) => {
          this.jobLabelsOpt = res.map((item) => {
            return {
              value: item,
              label: item
            }
          })
        })
        .catch((e) => {})
    },
    openDialog(title, row) {
      this.dialogTitle = title
      this.showDialog = true
      if (!row) return
      this.$nextTick(() => {
        let { jobType, isPublished } = row
        const {
          status,
          id,
          companyAccountId,
          companyId,
          jobTitleId,
          salaryRange,
          jobCategoryId,
          jobName,
          description,
          isMemberIndexHot,
          poiAddress,
          poiCity,
          poiDistrict,
          poiProvince,
          poiLat,
          poiLon,
          rejectReason
        } = row
        let { jobImages } = row
        jobImages = jobImages || []
        jobImages = jobImages.map((item, index) => {
          return {
            url: item,
            name: item + '' + index
          }
        })
        if (jobType === '全职') {
          jobType = 'FULL'
        }
        if (jobType === '兼职') {
          jobType = 'PART'
        }
        isPublished = isPublished ? 1 : 0
        this.checkedCities = row.jobLabels
        this.form = {
          status,
          id,
          companyAccountId,
          companyId,
          jobType,
          jobCategoryId,
          salaryRange,
          jobTitleId,
          isPublished,
          jobName,
          description,
          jobImages: jobImages,
          isMemberIndexHot,
          poiAddress,
          poiCity,
          poiDistrict,
          poiProvince,
          poiLat,
          poiLon,
          rejectReason
        }
        this.companyOpt = [
          {
            label: row.company.companyName,
            value: row.companyId
          }
        ]
      })
    },
    handleSubmit(isAdd) {
      if (!this.validateForm()) return
      const data = Object.assign({}, this.form)
      data.isPublished = Boolean(data.isPublished)
      data.jobLabels = this.checkedCities
      data.jobImages = data.jobImages.map((item) => item.url)
      if (isAdd) {
        console.log('data', data)
        this.loading = true
        this.$api.company
          .reqAddJob(data)
          .then((res) => {
            this.showDialog = false
            this.$message.success(res)
            this.getTableList()
            this.getVerifyCount()
          })
          .catch((e) => {
            this.$message.error(e)
          })
      } else {
        this.loading = true
        console.log('1111')
        this.$api.company
          .reqUpdateJob(data)
          .then((res) => {
            this.showDialog = false
            this.$message.success(res)
            this.getTableList()
            this.getVerifyCount()
          })
          .catch((e) => {
            this.$message.error(e)
          })
      }
    },
    handleDeleteCompany(row) {
      this.$confirm('此操作将永久删除该职位, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$api.company
            .reqDeleteJob({ ids: row.id })
            .then((res) => {
              this.$message({
                type: 'success',
                message: res
              })
              this.loading = true
              this.getTableList()
            })
            .catch((e) => {
              this.$message({
                type: 'info',
                message: e
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    handleFuliSuccess(res, file) {
      file.url = res.data
      this.form.jobImages = [...this.form.jobImages, file]
      this.$refs.form.clearValidate('jobImages')
    },
    handleFuliRemove(file) {
      this.form.jobImages = this.form.jobImages.filter((item) => item.url !== file.url)
      this.form.jobImages.length || this.$refs.form.validateField('jobImages')
    },
    resetForm() {
      console.log('这是深恶')
      console.log(this.$refs.form)
      this.$refs.form.resetFields()
      this.checkedCities = []
    },
    verifyAccount(status, id) {
      this.loading = true
      this.$api.company
        .reqUpdateJobStatus({ status, id })
        .then((res) => {
          this.loading = false
          this.getVerifyCount()
          this.$message.success('操作成功')
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e)
        })
    },
    refresh() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      this.$refs.screenForm.resetFields()
      this.checkedCities = []
      Promise.all([this.getVerifyCount(), this.getTableList()])
        .then(() => {
          this.loading = false
          this.statusCount.loading = false
        })
        .catch(() => {})
    },
    getVerifyCount() {
      this.statusCount.loading = true
      return this.$api.company
        .reqJobCount()
        .then((res) => {
          this.statusCount.count = res
          this.statusCount.loading = false
        })
        .catch((e) => {
          this.statusCount.loading = false
        })
    },
    handleSelectionChange(e) {
      this.ids = e.map((item) => item.id)
    },
    deleteGroup() {
      if (!this.ids.length) return this.$message.info('当前无选中项')
      this.$api.company
        .reqDeleteJob({ ids: this.ids.join(',') })
        .then((res) => {
          this.$message.success('操作成功')
          this.getTableList()
          this.getVerifyCount()
        })
        .catch((e) => {
          this.$message.error(e)
        })
    },
    validateForm() {
      let pass
      this.$refs.form.validate((res) => {
        pass = res
      })
      return pass
    },
    isImage(url) {
      const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
      let format = url.split('.')
      format = format[format.length - 1]
      if (imglist.some((item) => item === format)) {
        return true
      } else {
        return false
      }
    },
    previewVideo(url) {
      this.videoUrl = url
      this.previewVideoDialog = true
    }
  }
}
</script>
<style lang="scss" scoped>
.warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 84px);
  .company_heard_tool {
    margin-bottom: 10px;
  }
  .flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .isHot {
    border: none !important;
    background-color: #f19641;
  }
}

.area {
  width: max-content;
  padding: 0 10px;
  line-height: 30px;
  margin: 0 5px;
  border-radius: 6px;
  background-color: #f2f2f2;
  color: #666;
  margin-bottom: 15px;
}
.box-style {
  margin-right: 10px;
}
</style>
